import { render, staticRenderFns } from "./task-priority.vue?vue&type=template&id=25fa4413&scoped=true&"
import script from "./task-priority.vue?vue&type=script&lang=js&"
export * from "./task-priority.vue?vue&type=script&lang=js&"
import style0 from "./task-priority.vue?vue&type=style&index=0&id=25fa4413&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25fa4413",
  null
  
)

export default component.exports